import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "./components_root/ToastContext";
import { HelmetProvider } from "react-helmet-async";
import { db } from "./firebase";
import Cookies from "js-cookie";

import { collection, getDocs, query, where, limit } from "firebase/firestore";


const initWebsite = async () => {
  try {
    const rawHost = window.location.hostname || "default";

    const isLocal =
      rawHost === "localhost" || rawHost === "127.0.0.1";

    const hostname = isLocal
      ? "aooz.in"
      : rawHost.replace(/^www\./, "");

    const parts = hostname.split(".");
    const subdomain =
      parts.length > 2 ? parts.slice(0, -2).join(".") : null;

    const rootDomain = parts.slice(-2).join(".");
    const cookieDomain = isLocal ? undefined : "." + rootDomain;

    const cookieOptions = {
      expires: 90,
      path: "/",
      ...(cookieDomain ? { domain: cookieDomain } : {}),
      secure: !isLocal,
      sameSite: !isLocal ? "None" : "Lax"
    };

    // 🔥 debug cookie
    Cookies.set(
      "domain_company_uid",
      rootDomain + "_" + hostname,
      cookieOptions
    );

    let companySnap;

    // ✅ 1. subdomain (FIXED FIELD)
    if (subdomain) {
      companySnap = await getDocs(
        query(
          collection(db, "companies"),
          where("subdomain", "==", subdomain), // ✅ FIXED
          where("status", "==", true),
          limit(1)
        )
      );
    }

    // ✅ 2. full domain
    if (!companySnap || companySnap.empty) {
      companySnap = await getDocs(
        query(
          collection(db, "companies"),
          where("domain_registration", "==", hostname),
          where("status", "==", true),
          limit(1)
        )
      );
    }

    // ✅ 3. root domain
    if (!companySnap || companySnap.empty) {
      companySnap = await getDocs(
        query(
          collection(db, "companies"),
          where("domain_registration", "==", rootDomain),
          where("status", "==", true),
          limit(1)
        )
      );
    }

    let companyId = "jeghYxIDZYkgUVYOaiAlOR4Xp7";

    if (companySnap && !companySnap.empty) {
      const data = companySnap.docs[0].data();
      companyId = data.companyuid || companyId;

      console.log("✅ Company loaded:", companyId);
    } else {
      console.log("⚠️ Default company loaded");
    }

    // 🔥 ✅ FORCE REPLACE COOKIE (IMPORTANT)
    const existing = Cookies.get("website_company_uid");

    if (existing !== companyId) {
      // ❌ remove old cookie (important for domain mismatch)
      Cookies.remove("website_company_uid", { path: "/" });
      if (cookieDomain) {
        Cookies.remove("website_company_uid", {
          path: "/",
          domain: cookieDomain
        });
      }

      // ✅ set new cookie
      Cookies.set("website_company_uid", companyId, cookieOptions);

      console.log("🍪 Cookie replaced:", companyId);
    } else {
      console.log("🍪 Cookie already correct");
    }

  } catch (err) {
    console.error("❌ Company detect error:", err);

    Cookies.set("website_company_uid", "jeghYxIDZYkgUVYOaiAlOR4Xp7");
  }
};
const root = ReactDOM.createRoot(document.getElementById("root"));

initWebsite().then(() => {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ToastProvider>
         <HelmetProvider>
  <App />
</HelmetProvider>
        </ToastProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});

reportWebVitals();